/* eslint semi: 1 */
import { defineStore } from 'pinia';
import { TAG_TYPE_STATE_KEY, PLAYER_SCHEDULES_STATE_KEY, POP_IDS_STATE_KEY } from './storeUtils.js';
import _ from 'lodash';

export const addSelectedAttribute = (tags, selected) => {
  if (!_.isArray(selected)) {
    return tags;
  }

  return _.map(tags, (tag) => {
    return { ...tag, isSelected: _.some(selected, { uid: tag.uid }) };
  });
};

export const selectionStore = (storeId) => {
  return defineStore(`${storeId}-selection-store`, {
    state: () => ({
      [TAG_TYPE_STATE_KEY.RESOURCE_TAGS]: [],
      [TAG_TYPE_STATE_KEY.LED_TAGS]: [],
      [TAG_TYPE_STATE_KEY.VIDEOWALL_TAGS]: [],
      [TAG_TYPE_STATE_KEY.PLAYER_TAGS]: [],
      [POP_IDS_STATE_KEY]: [],
      [PLAYER_SCHEDULES_STATE_KEY]: []
    }),
    getters: {
      /**
       * Getters to return typed tags with additional isSelected attribute
       */
      resourceTagsWithSelection: (state) => {
        return (tags) => addSelectedAttribute(tags, state[TAG_TYPE_STATE_KEY.RESOURCE_TAGS]);
      },
      ledTagsWithSelection: (state) => {
        return (tags) => addSelectedAttribute(tags, state[TAG_TYPE_STATE_KEY.LED_TAGS]);
      },
      videowallTagsWithSelection: (state) => {
        return (tags) => addSelectedAttribute(tags, state[TAG_TYPE_STATE_KEY.VIDEOWALL_TAGS]);
      },
      popIdsWithSelection: (state) => {
        return (tags) => addSelectedAttribute(tags, state[POP_IDS_STATE_KEY]);
      },
      playerWithSelection: (state) => {
        return (tags) => addSelectedAttribute(tags, state[PLAYER_SCHEDULES_STATE_KEY]);
      }

    },
    actions: ({
      /**
       * This function is commonly used to update selection data
       * @param {String} stateKey
       * @param {Array} items
       */
      updateSelectionStateData (stateKey, items) {
        if (_.isEmpty(stateKey) || !_.isArray(items)) {
          return;
        }

        this[stateKey] = items.filter((tag) => tag.value !== '_toSeeAllData');
      },
      /**
       * This function is commonly used to clear selection data
       * @param {String} stateKey
       */
      clearSelectionStateData (stateKey) {
        this[stateKey] = [];
      },
      /**
       * Files Screen Actions
       */
      updateResourceTagsSelection (items) {
        this.updateSelectionStateData(TAG_TYPE_STATE_KEY.RESOURCE_TAGS, items);
      },
      updateLEDTagsSelection (items) {
        this.updateSelectionStateData(TAG_TYPE_STATE_KEY.LED_TAGS, items);
      },
      updateVideowallTagsSelection (items) {
        this.updateSelectionStateData(TAG_TYPE_STATE_KEY.VIDEOWALL_TAGS, items);
      },
      updatePlayerTagsSelection (items) {
        this.updateSelectionStateData(TAG_TYPE_STATE_KEY.PLAYER_TAGS, items);
      },
      updatePopIdsSelection (items) {
        this.updateSelectionStateData(POP_IDS_STATE_KEY, items);
      },
      updatePlayerScheduleSelection (items) {
        this.updateSelectionStateData(PLAYER_SCHEDULES_STATE_KEY, items);
      },
      clearResourceTagsSelection () {
        this.clearSelectionStateData(TAG_TYPE_STATE_KEY.RESOURCE_TAGS);
      },
      clearLEDTagsSelection () {
        this.clearSelectionStateData(TAG_TYPE_STATE_KEY.LED_TAGS);
      },
      clearVideowallTagsSelection () {
        this.clearSelectionStateData(TAG_TYPE_STATE_KEY.VIDEOWALL_TAGS);
      },
      clearPlayerTagsSelection () {
        this.clearSelectionStateData(TAG_TYPE_STATE_KEY.PLAYER_TAGS);
      },
      clearPopIdsSelection () {
        this.clearSelectionStateData(POP_IDS_STATE_KEY);
      },
      clearPlayerScheduleSelection () {
        this.clearSelectionStateData(PLAYER_SCHEDULES_STATE_KEY);
      },
      clearState () {
        this.clearResourceTagsSelection();
        this.clearLEDTagsSelection();
        this.clearVideowallTagsSelection();
        this.clearPlayerTagsSelection();
        this.clearPopIdsSelection();
        this.clearPlayerScheduleSelection();
      }
    })
  });
};
